/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import swal from 'sweetalert';
import intlTelInput from 'intl-tel-input';
import  'packs/libs/jquery_steps';

import { UploadDirectFile } from "packs/libs/uploader/upload_direct_file";

import validate from 'jquery-validation';
require("packs/libs/validate/messages_es");

document.addEventListener("DOMContentLoaded", function(event) {
    var amountAdmission = $("#payment_information").data("amount");
    $("#payment_information").removeAttr("data-amount");
    /*
     * BEGIN: 
     * @type steps
     * 
     */
    $("#registration-wizard").steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "slideLeft",
            autoFocus: true,
          
            labels:{
                next: $("#registration-wizard").data("labels-next"),
                previous: $("#registration-wizard").data("labels-previous"),
                cancel: $("#registration-wizard").data("labels-cancel"),
                finish: $("#registration-wizard").data("labels-finish"),
            },
            onStepChanged: function (event, currentIndex, priorIndex) { 
                
            },
            onFinished: function (event, currentIndex) { 
                
            },
            onInit:function (event, currentIndex) { 
                $(event.currentTarget).find("a[href='#finish']").hide();
                $(event.currentTarget).find("a[href='#finish']").parent().append($(".submit_new_user"));
                
                
            }
            
    });
    /*
     * END: 
     * @type steps
     * 
     */
    
    /*
     * Begin: 
     * @type DisplayName
     * 
     */
    
        $(".for_display_name").keyup(function() {
            const first_name = $("#profile_first_name").val().split(" ")[0];
            const last_name = $("#profile_last_name").val().split(" ")[0];
            $("#profile_display_name").val(first_name + " "+ last_name);
        });
    /*
     * END: 
     * @type DisplayName
     * 
     */
    
    /*
     * Begin: 
     * @type TrainerCheck
     * 
     */
    
        $("#crm_member_trainer").click(function() {
            //const $trainer_brand_container = $("#crm_member_trainer_brand").parent();
           if($(this).is(":checked")){
               //$trainer_brand_container.removeClass("hide");
               $("#crm_member_trainer_brand").removeAttr("disabled").val("");
           }else{
               $("#crm_member_trainer_brand").attr("disabled").val("");
               //$trainer_brand_container.addClass("hide")
           }
        });
    /*
     * END: 
     * @type TrainerCheck
     * 
     */
    
    
       /*
     * BEGIN: 
     * @type paymentFrequencies.Labels.Events
     * 
     */
    
        $(".payment_frequency label").click(function() {
           
            $(".payment_frequency").removeClass("selected").addClass("unselected");
            $(this).parents(".payment_frequency").first().addClass("selected").removeClass("unselected");
            $(".payment-method-container").addClass("enabled").removeClass("disabled");
            amountAdmission = $(this).data("amount");
        });
        if($(".payment_frequency label").length === 1){
            $(".payment_frequency label").first().click();
        }
    
    /*
     * END: 
     * @type paymentFrequencies.Labels.Events
     * 
     */
    
    
    /*
     * BEGIN: 
     * @type intlTelInput
     * 
     */
        var input = document.querySelector("#profile_fullphone");
        intlTelInput(input, {
            initialCountry: document.querySelector("#profile_fullphone").dataset.countryCode,
            preferredCountries: ['mx', 've'],
            separateDialCode: true, 
            hiddenInput: "phone",
            utilsScript: document.querySelector("#profile_fullphone").dataset.utilsUrl
        
        });
    /*
     * END: 
     * @type intlTelInput
     * 
     */
    
    const inputAdmission = document.querySelector("#crm_member_crm_admission_id");
    if(inputAdmission.value === "")
    swal({
                        title: inputAdmission.dataset.notActiveAdmission,
                        text: inputAdmission.dataset.messageNotActiveAdmission,
                        icon: "error",
                        closeOnEsc: false,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        button: "Ok"
                }).then((value) => {
                    window.location.href = "https://www.clala.lat"  
                });

    /*
     * BEGIN: 
     * @type ScollDown
     * 
     */
    
        const elementPosition = $("header").offset();
        if($(window).scrollTop() >= 2)
            $("header").addClass('down');
         else 
        $("header").removeClass('down');
        $(window).scroll(function(){
            if($(window).scrollTop() >= 2)
                $("header").addClass('down');
             else 
                $("header").removeClass('down');
        });
    /*
     * END: 
     * @type ScollDown
     * 
     */
    
    /*
     * BEGIN: 
     * @type UploadFiles
     * 
     */

    const upload = new UploadDirectFile('input[type=file]');
    upload.build();

     /*
     * END: 
     * @type UploadFiles
     * 
     */
 });




